import { compose, flattenProp, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import messages from './messages';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import { functionalGroup } from 'reducers/functionalGroups/selectors';
import {
  charmsForTemplate,
  designPackageForTemplate,
  template,
} from 'reducers/templates/selectors';
import { templateDetailImagesLoading } from 'reducers/loading/selectors';
import { priceBands } from 'reducers/models/selectors';
import { mini, addDisclaimer } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import formatCurrency from 'utils/formatCurrency';
import { fetchTemplateDetailImages } from 'reducers/templates/actions';

const mapStateToProps = combineSelectors({
  addDisclaimer,
  charmsForTemplate,
  designPackageForTemplate,
  functionalGroup,
  templateDetailImagesLoading,
  mini,
  priceBands,
  template,
});

const mapDispatchToProps = {
  fetchTemplateDetailImages,
};

function componentDidMount() {
  const { fetchTemplateDetailImages, templateId } = this.props;
  fetchTemplateDetailImages({ templateId });
}

const formattedTotalPrice = formatCurrency({
  priceProp: 'totalPrice',
  currencyProp: 'currency',
});

const formattedPriceBandMax = formatCurrency({
  priceProp: 'priceBandMax',
  currencyProp: 'currency',
});

const formattedPriceBandMin = formatCurrency({
  priceProp: 'priceBandMin',
  currencyProp: 'currency',
});

export const priceBand = ({ priceBands, priceBandId }) =>
  priceBands.find(priceBand => priceBand.id === priceBandId);
export const priceBandMax = ({ priceBand }) => priceBand.max;
export const priceBandMin = ({ priceBand }) => priceBand.min;

export const formattedPriceBand = ({
  addDisclaimer,
  formattedPriceBandMin,
  formattedPriceBandMax,
  priceBand,
}) => {
  if (priceBand.max < 1000000) {
    return `${formattedPriceBandMin} - ${formattedPriceBandMax}`;
  } else {
    return `${formattedPriceBandMin}+`;
  }
};

export const suggestedUnits = ({ suggestedQuant, unit, units }) =>
  suggestedQuant > 1 ? units : unit;

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'currency',
      'totalPriceLabel',
      'priceBandLabel',
      'suggestedLabel',
      'functionalGroupHeader',
      'designPackageHeader',
      'templateOverviewHeader',
      'units',
      'unit',
      'detailString',
      'closeString',
    ],
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({ componentDidMount }),
  flattenProp('template'),
  flattenProp('functionalGroup'),
  flattenProp('designPackageForTemplate'),
  addProps({
    priceBand,
    suggestedUnits,
  }),
  addProps({
    priceBandMax,
    priceBandMin,
  }),
  addProps({
    formattedTotalPrice,
    formattedPriceBandMax,
    formattedPriceBandMin,
  }),
  addProps({
    formattedPriceBand,
  }),
);
